export const BUTTON_MAX_HEIGHT = 48;
export const BUTTON_MIN_WIDTH = 124;
